import styled from 'styled-components';
import RichText from '../rich-text';
import { layout } from 'src/components/base';

export const FaqContainer = styled.div`
  margin: ${layout.measurements.spacing050};
`;

export const span = styled(RichText)`
  & > :last-child {
    margin-bottom: 0 !important;
  }

  & a {
    color: ${p => p.theme.text.linkExternal};
  }

  & a:hover {
    color: ${p => p.theme.text.linkExternalHover};
  }
`;
